import { render } from "./UserProfileSettings.vue?vue&type=template&id=daab3538&scoped=true"
import script from "./UserProfileSettings.vue?vue&type=script&lang=js"
export * from "./UserProfileSettings.vue?vue&type=script&lang=js"

import "./UserProfileSettings.vue?vue&type=style&index=0&id=daab3538&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daab3538"]])

export default __exports__